import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { RefulfillmentInventoryPushRequest } from "./refulfillment-inventory-push-request";

const RefulfillmentPreviewRow_ = z.object({
  productId: z.string(),
  productTitle: z.string(),
  variantTitle: z.string().nullable(),
  sku: z.string().nullable(),
  availableQuantity: z.number(),
  maxQuantity: z.number().nullable(),
  /** Shopify "available" now; null when the item has no level there. */
  currentQuantity: z.number().nullable(),
  targetQuantity: z.number(),
  action: z.enum(["activate", "update", "deactivate", "unchanged", "skipped"]),
  skipReason: z
    .enum(["missing_location_mapping", "missing_inventory_item"])
    .nullable(),
});
export const RefulfillmentPreviewRow: z.ZodType<RefulfillmentPreviewRow> =
  RefulfillmentPreviewRow_;
export interface RefulfillmentPreviewRow extends z.infer<
  typeof RefulfillmentPreviewRow_
> {}

const RefulfillmentPreviewLocation_ = z.object({
  sourceLocationId: z.string(),
  name: z.string(),
  rows: z.array(RefulfillmentPreviewRow_),
  /** The location has more rows than the preview shows; the push covers all. */
  truncated: z.boolean(),
  /** Set when an eligibility gate would stop the push at this location. */
  stopReason: z.string().nullable(),
});
export const RefulfillmentPreviewLocation: z.ZodType<RefulfillmentPreviewLocation> =
  RefulfillmentPreviewLocation_;
export interface RefulfillmentPreviewLocation extends z.infer<
  typeof RefulfillmentPreviewLocation_
> {}

/** Read-only: current versus proposed Shopify inventory for a push request. */
export const previewRefulfillmentInventoryPush = unaryRpc({
  name: "previewRefulfillmentInventoryPush" as const,
  input: RefulfillmentInventoryPushRequest,
  output: z.object({
    inventoryPushMinimumQuantity: z.number(),
    locations: z.array(RefulfillmentPreviewLocation_),
  }),
});
